/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as BookSlugRouteImport } from './routes/book/$slug'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthedTasksIndexRouteImport } from './routes/_authed/tasks/index'
import { Route as AuthedSubscriptionsIndexRouteImport } from './routes/_authed/subscriptions/index'
import { Route as AuthedSettingsIndexRouteImport } from './routes/_authed/settings/index'
import { Route as AuthedSequencesIndexRouteImport } from './routes/_authed/sequences/index'
import { Route as AuthedRetentionIndexRouteImport } from './routes/_authed/retention/index'
import { Route as AuthedProductsIndexRouteImport } from './routes/_authed/products/index'
import { Route as AuthedOrdersIndexRouteImport } from './routes/_authed/orders/index'
import { Route as AuthedLogsIndexRouteImport } from './routes/_authed/logs/index'
import { Route as AuthedLeadsIndexRouteImport } from './routes/_authed/leads/index'
import { Route as AuthedInvoicesIndexRouteImport } from './routes/_authed/invoices/index'
import { Route as AuthedEngagementIndexRouteImport } from './routes/_authed/engagement/index'
import { Route as AuthedEmailIndexRouteImport } from './routes/_authed/email/index'
import { Route as AuthedDealsIndexRouteImport } from './routes/_authed/deals/index'
import { Route as AuthedContactsIndexRouteImport } from './routes/_authed/contacts/index'
import { Route as AuthedCompaniesIndexRouteImport } from './routes/_authed/companies/index'
import { Route as AuthedBookingsIndexRouteImport } from './routes/_authed/bookings/index'
import { Route as AuthedBasketsIndexRouteImport } from './routes/_authed/baskets/index'
import { Route as AuthedAutomationsIndexRouteImport } from './routes/_authed/automations/index'
import { Route as AuthedApprovalsIndexRouteImport } from './routes/_authed/approvals/index'
import { Route as AuthedAnalyticsIndexRouteImport } from './routes/_authed/analytics/index'
import { Route as AuthedAgentWorkspaceIndexRouteImport } from './routes/_authed/agent-workspace/index'
import { Route as BookingIdRescheduleRouteImport } from './routes/booking/$id.reschedule'
import { Route as BookingIdCancelRouteImport } from './routes/booking/$id.cancel'
import { Route as AuthedSubscriptionsSubscriptionIdRouteImport } from './routes/_authed/subscriptions/$subscriptionId'
import { Route as AuthedSettingsTeamsRouteImport } from './routes/_authed/settings/teams'
import { Route as AuthedSettingsNavigationRouteImport } from './routes/_authed/settings/navigation'
import { Route as AuthedSettingsModelProvidersRouteImport } from './routes/_authed/settings/model-providers'
import { Route as AuthedSettingsFieldsRouteImport } from './routes/_authed/settings/fields'
import { Route as AuthedRetentionTriggersRouteImport } from './routes/_authed/retention/triggers'
import { Route as AuthedRetentionRenewalsRouteImport } from './routes/_authed/retention/renewals'
import { Route as AuthedRetentionOpportunitiesRouteImport } from './routes/_authed/retention/opportunities'
import { Route as AuthedRetentionCancellationsRouteImport } from './routes/_authed/retention/cancellations'
import { Route as AuthedLogsMessagesRouteImport } from './routes/_authed/logs/messages'
import { Route as AuthedLogsChangeHistoryRouteImport } from './routes/_authed/logs/change-history'
import { Route as AuthedInvoicesInvoiceIdRouteImport } from './routes/_authed/invoices/$invoiceId'
import { Route as AuthedEngagementPreferencesRouteImport } from './routes/_authed/engagement/preferences'
import { Route as AuthedEngagementEventsRouteImport } from './routes/_authed/engagement/events'
import { Route as AuthedEngagementEventIdRouteImport } from './routes/_authed/engagement/$eventId'
import { Route as AuthedDealsDealIdRouteImport } from './routes/_authed/deals/$dealId'
import { Route as AuthedContactsContactIdRouteImport } from './routes/_authed/contacts/$contactId'
import { Route as AuthedCompaniesCompanyIdRouteImport } from './routes/_authed/companies/$companyId'
import { Route as AuthedBookingsWorkflowsRouteImport } from './routes/_authed/bookings/workflows'
import { Route as AuthedBookingsEventTypesRouteImport } from './routes/_authed/bookings/event-types'
import { Route as AuthedBookingsAvailabilityRouteImport } from './routes/_authed/bookings/availability'
import { Route as AuthedAutomationsNewRouteImport } from './routes/_authed/automations/new'
import { Route as AuthedAnalyticsReportsRouteImport } from './routes/_authed/analytics/reports'
import { Route as AuthedAnalyticsPipelineRouteImport } from './routes/_authed/analytics/pipeline'
import { Route as AuthedAgentWorkspaceSkillsRouteImport } from './routes/_authed/agent-workspace/skills'
import { Route as AuthedAgentWorkspaceRunsRouteImport } from './routes/_authed/agent-workspace/runs'
import { Route as AuthedAgentWorkspaceMonitorRouteImport } from './routes/_authed/agent-workspace/monitor'
import { Route as AuthedAgentWorkspaceModelsRouteImport } from './routes/_authed/agent-workspace/models'
import { Route as AuthedAgentWorkspaceMemoryRouteImport } from './routes/_authed/agent-workspace/memory'
import { Route as AuthedAgentWorkspaceFunctionsRouteImport } from './routes/_authed/agent-workspace/functions'
import { Route as AuthedAgentWorkspaceAutomationsRouteImport } from './routes/_authed/agent-workspace/automations'
import { Route as AuthedAgentWorkspaceRunIdRouteImport } from './routes/_authed/agent-workspace/$runId'
import { Route as AuthedSettingsPacksIndexRouteImport } from './routes/_authed/settings/packs/index'
import { Route as AuthedSettingsMigrationIndexRouteImport } from './routes/_authed/settings/migration/index'
import { Route as AuthedSettingsIntegrationsIndexRouteImport } from './routes/_authed/settings/integrations/index'
import { Route as AuthedSettingsGeneralIndexRouteImport } from './routes/_authed/settings/general/index'
import { Route as AuthedSettingsEnrichmentIndexRouteImport } from './routes/_authed/settings/enrichment/index'
import { Route as AuthedBookingsEventTypesIndexRouteImport } from './routes/_authed/bookings/event-types/index'
import { Route as AuthedBookingsAvailabilityIndexRouteImport } from './routes/_authed/bookings/availability/index'
import { Route as AuthedAnalyticsEventsIndexRouteImport } from './routes/_authed/analytics/events/index'
import { Route as AuthedSettingsPacksPackIdRouteImport } from './routes/_authed/settings/packs/$packId'
import { Route as AuthedSettingsGeneralRolesRouteImport } from './routes/_authed/settings/general/roles'
import { Route as AuthedSettingsGeneralMembersRouteImport } from './routes/_authed/settings/general/members'
import { Route as AuthedBookingsEventTypesIdRouteImport } from './routes/_authed/bookings/event-types/$id'
import { Route as AuthedBookingsAvailabilityIdRouteImport } from './routes/_authed/bookings/availability/$id'
import { Route as AuthedAutomationsWorkflowIdEditRouteImport } from './routes/_authed/automations/$workflowId/edit'
import { Route as AuthedAnalyticsEventsEventIdRouteImport } from './routes/_authed/analytics/events/$eventId'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const BookSlugRoute = BookSlugRouteImport.update({
  id: '/book/$slug',
  path: '/book/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthedTasksIndexRoute = AuthedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSubscriptionsIndexRoute =
  AuthedSubscriptionsIndexRouteImport.update({
    id: '/subscriptions/',
    path: '/subscriptions/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsIndexRoute = AuthedSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSequencesIndexRoute = AuthedSequencesIndexRouteImport.update({
  id: '/sequences/',
  path: '/sequences/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRetentionIndexRoute = AuthedRetentionIndexRouteImport.update({
  id: '/retention/',
  path: '/retention/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProductsIndexRoute = AuthedProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOrdersIndexRoute = AuthedOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLogsIndexRoute = AuthedLogsIndexRouteImport.update({
  id: '/logs/',
  path: '/logs/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLeadsIndexRoute = AuthedLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInvoicesIndexRoute = AuthedInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEngagementIndexRoute = AuthedEngagementIndexRouteImport.update({
  id: '/engagement/',
  path: '/engagement/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEmailIndexRoute = AuthedEmailIndexRouteImport.update({
  id: '/email/',
  path: '/email/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDealsIndexRoute = AuthedDealsIndexRouteImport.update({
  id: '/deals/',
  path: '/deals/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedContactsIndexRoute = AuthedContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCompaniesIndexRoute = AuthedCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBookingsIndexRoute = AuthedBookingsIndexRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBasketsIndexRoute = AuthedBasketsIndexRouteImport.update({
  id: '/baskets/',
  path: '/baskets/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAutomationsIndexRoute = AuthedAutomationsIndexRouteImport.update({
  id: '/automations/',
  path: '/automations/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedApprovalsIndexRoute = AuthedApprovalsIndexRouteImport.update({
  id: '/approvals/',
  path: '/approvals/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsIndexRoute = AuthedAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentWorkspaceIndexRoute =
  AuthedAgentWorkspaceIndexRouteImport.update({
    id: '/agent-workspace/',
    path: '/agent-workspace/',
    getParentRoute: () => AuthedRoute,
  } as any)
const BookingIdRescheduleRoute = BookingIdRescheduleRouteImport.update({
  id: '/booking/$id/reschedule',
  path: '/booking/$id/reschedule',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingIdCancelRoute = BookingIdCancelRouteImport.update({
  id: '/booking/$id/cancel',
  path: '/booking/$id/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSubscriptionsSubscriptionIdRoute =
  AuthedSubscriptionsSubscriptionIdRouteImport.update({
    id: '/subscriptions/$subscriptionId',
    path: '/subscriptions/$subscriptionId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsTeamsRoute = AuthedSettingsTeamsRouteImport.update({
  id: '/settings/teams',
  path: '/settings/teams',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsNavigationRoute =
  AuthedSettingsNavigationRouteImport.update({
    id: '/settings/navigation',
    path: '/settings/navigation',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsModelProvidersRoute =
  AuthedSettingsModelProvidersRouteImport.update({
    id: '/settings/model-providers',
    path: '/settings/model-providers',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsFieldsRoute = AuthedSettingsFieldsRouteImport.update({
  id: '/settings/fields',
  path: '/settings/fields',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRetentionTriggersRoute = AuthedRetentionTriggersRouteImport.update({
  id: '/retention/triggers',
  path: '/retention/triggers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRetentionRenewalsRoute = AuthedRetentionRenewalsRouteImport.update({
  id: '/retention/renewals',
  path: '/retention/renewals',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRetentionOpportunitiesRoute =
  AuthedRetentionOpportunitiesRouteImport.update({
    id: '/retention/opportunities',
    path: '/retention/opportunities',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRetentionCancellationsRoute =
  AuthedRetentionCancellationsRouteImport.update({
    id: '/retention/cancellations',
    path: '/retention/cancellations',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedLogsMessagesRoute = AuthedLogsMessagesRouteImport.update({
  id: '/logs/messages',
  path: '/logs/messages',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLogsChangeHistoryRoute = AuthedLogsChangeHistoryRouteImport.update({
  id: '/logs/change-history',
  path: '/logs/change-history',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInvoicesInvoiceIdRoute = AuthedInvoicesInvoiceIdRouteImport.update({
  id: '/invoices/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEngagementPreferencesRoute =
  AuthedEngagementPreferencesRouteImport.update({
    id: '/engagement/preferences',
    path: '/engagement/preferences',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedEngagementEventsRoute = AuthedEngagementEventsRouteImport.update({
  id: '/engagement/events',
  path: '/engagement/events',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEngagementEventIdRoute = AuthedEngagementEventIdRouteImport.update({
  id: '/engagement/$eventId',
  path: '/engagement/$eventId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDealsDealIdRoute = AuthedDealsDealIdRouteImport.update({
  id: '/deals/$dealId',
  path: '/deals/$dealId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedContactsContactIdRoute = AuthedContactsContactIdRouteImport.update({
  id: '/contacts/$contactId',
  path: '/contacts/$contactId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCompaniesCompanyIdRoute =
  AuthedCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedBookingsWorkflowsRoute = AuthedBookingsWorkflowsRouteImport.update({
  id: '/bookings/workflows',
  path: '/bookings/workflows',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBookingsEventTypesRoute =
  AuthedBookingsEventTypesRouteImport.update({
    id: '/bookings/event-types',
    path: '/bookings/event-types',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedBookingsAvailabilityRoute =
  AuthedBookingsAvailabilityRouteImport.update({
    id: '/bookings/availability',
    path: '/bookings/availability',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAutomationsNewRoute = AuthedAutomationsNewRouteImport.update({
  id: '/automations/new',
  path: '/automations/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsReportsRoute = AuthedAnalyticsReportsRouteImport.update({
  id: '/analytics/reports',
  path: '/analytics/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsPipelineRoute = AuthedAnalyticsPipelineRouteImport.update({
  id: '/analytics/pipeline',
  path: '/analytics/pipeline',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentWorkspaceSkillsRoute =
  AuthedAgentWorkspaceSkillsRouteImport.update({
    id: '/agent-workspace/skills',
    path: '/agent-workspace/skills',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgentWorkspaceRunsRoute =
  AuthedAgentWorkspaceRunsRouteImport.update({
    id: '/agent-workspace/runs',
    path: '/agent-workspace/runs',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgentWorkspaceMonitorRoute =
  AuthedAgentWorkspaceMonitorRouteImport.update({
    id: '/agent-workspace/monitor',
    path: '/agent-workspace/monitor',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgentWorkspaceModelsRoute =
  AuthedAgentWorkspaceModelsRouteImport.update({
    id: '/agent-workspace/models',
    path: '/agent-workspace/models',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgentWorkspaceMemoryRoute =
  AuthedAgentWorkspaceMemoryRouteImport.update({
    id: '/agent-workspace/memory',
    path: '/agent-workspace/memory',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgentWorkspaceFunctionsRoute =
  AuthedAgentWorkspaceFunctionsRouteImport.update({
    id: '/agent-workspace/functions',
    path: '/agent-workspace/functions',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgentWorkspaceAutomationsRoute =
  AuthedAgentWorkspaceAutomationsRouteImport.update({
    id: '/agent-workspace/automations',
    path: '/agent-workspace/automations',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAgentWorkspaceRunIdRoute =
  AuthedAgentWorkspaceRunIdRouteImport.update({
    id: '/agent-workspace/$runId',
    path: '/agent-workspace/$runId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsPacksIndexRoute =
  AuthedSettingsPacksIndexRouteImport.update({
    id: '/settings/packs/',
    path: '/settings/packs/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsMigrationIndexRoute =
  AuthedSettingsMigrationIndexRouteImport.update({
    id: '/settings/migration/',
    path: '/settings/migration/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsIntegrationsIndexRoute =
  AuthedSettingsIntegrationsIndexRouteImport.update({
    id: '/settings/integrations/',
    path: '/settings/integrations/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsGeneralIndexRoute =
  AuthedSettingsGeneralIndexRouteImport.update({
    id: '/settings/general/',
    path: '/settings/general/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsEnrichmentIndexRoute =
  AuthedSettingsEnrichmentIndexRouteImport.update({
    id: '/settings/enrichment/',
    path: '/settings/enrichment/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedBookingsEventTypesIndexRoute =
  AuthedBookingsEventTypesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedBookingsEventTypesRoute,
  } as any)
const AuthedBookingsAvailabilityIndexRoute =
  AuthedBookingsAvailabilityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedBookingsAvailabilityRoute,
  } as any)
const AuthedAnalyticsEventsIndexRoute =
  AuthedAnalyticsEventsIndexRouteImport.update({
    id: '/analytics/events/',
    path: '/analytics/events/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsPacksPackIdRoute =
  AuthedSettingsPacksPackIdRouteImport.update({
    id: '/settings/packs/$packId',
    path: '/settings/packs/$packId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsGeneralRolesRoute =
  AuthedSettingsGeneralRolesRouteImport.update({
    id: '/settings/general/roles',
    path: '/settings/general/roles',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsGeneralMembersRoute =
  AuthedSettingsGeneralMembersRouteImport.update({
    id: '/settings/general/members',
    path: '/settings/general/members',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedBookingsEventTypesIdRoute =
  AuthedBookingsEventTypesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthedBookingsEventTypesRoute,
  } as any)
const AuthedBookingsAvailabilityIdRoute =
  AuthedBookingsAvailabilityIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthedBookingsAvailabilityRoute,
  } as any)
const AuthedAutomationsWorkflowIdEditRoute =
  AuthedAutomationsWorkflowIdEditRouteImport.update({
    id: '/automations/$workflowId/edit',
    path: '/automations/$workflowId/edit',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAnalyticsEventsEventIdRoute =
  AuthedAnalyticsEventsEventIdRouteImport.update({
    id: '/analytics/events/$eventId',
    path: '/analytics/events/$eventId',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
  '/book/$slug': typeof BookSlugRoute
  '/agent-workspace/$runId': typeof AuthedAgentWorkspaceRunIdRoute
  '/agent-workspace/automations': typeof AuthedAgentWorkspaceAutomationsRoute
  '/agent-workspace/functions': typeof AuthedAgentWorkspaceFunctionsRoute
  '/agent-workspace/memory': typeof AuthedAgentWorkspaceMemoryRoute
  '/agent-workspace/models': typeof AuthedAgentWorkspaceModelsRoute
  '/agent-workspace/monitor': typeof AuthedAgentWorkspaceMonitorRoute
  '/agent-workspace/runs': typeof AuthedAgentWorkspaceRunsRoute
  '/agent-workspace/skills': typeof AuthedAgentWorkspaceSkillsRoute
  '/analytics/pipeline': typeof AuthedAnalyticsPipelineRoute
  '/analytics/reports': typeof AuthedAnalyticsReportsRoute
  '/automations/new': typeof AuthedAutomationsNewRoute
  '/bookings/availability': typeof AuthedBookingsAvailabilityRouteWithChildren
  '/bookings/event-types': typeof AuthedBookingsEventTypesRouteWithChildren
  '/bookings/workflows': typeof AuthedBookingsWorkflowsRoute
  '/companies/$companyId': typeof AuthedCompaniesCompanyIdRoute
  '/contacts/$contactId': typeof AuthedContactsContactIdRoute
  '/deals/$dealId': typeof AuthedDealsDealIdRoute
  '/engagement/$eventId': typeof AuthedEngagementEventIdRoute
  '/engagement/events': typeof AuthedEngagementEventsRoute
  '/engagement/preferences': typeof AuthedEngagementPreferencesRoute
  '/invoices/$invoiceId': typeof AuthedInvoicesInvoiceIdRoute
  '/logs/change-history': typeof AuthedLogsChangeHistoryRoute
  '/logs/messages': typeof AuthedLogsMessagesRoute
  '/retention/cancellations': typeof AuthedRetentionCancellationsRoute
  '/retention/opportunities': typeof AuthedRetentionOpportunitiesRoute
  '/retention/renewals': typeof AuthedRetentionRenewalsRoute
  '/retention/triggers': typeof AuthedRetentionTriggersRoute
  '/settings/fields': typeof AuthedSettingsFieldsRoute
  '/settings/model-providers': typeof AuthedSettingsModelProvidersRoute
  '/settings/navigation': typeof AuthedSettingsNavigationRoute
  '/settings/teams': typeof AuthedSettingsTeamsRoute
  '/subscriptions/$subscriptionId': typeof AuthedSubscriptionsSubscriptionIdRoute
  '/booking/$id/cancel': typeof BookingIdCancelRoute
  '/booking/$id/reschedule': typeof BookingIdRescheduleRoute
  '/agent-workspace/': typeof AuthedAgentWorkspaceIndexRoute
  '/analytics/': typeof AuthedAnalyticsIndexRoute
  '/approvals/': typeof AuthedApprovalsIndexRoute
  '/automations/': typeof AuthedAutomationsIndexRoute
  '/baskets/': typeof AuthedBasketsIndexRoute
  '/bookings/': typeof AuthedBookingsIndexRoute
  '/companies/': typeof AuthedCompaniesIndexRoute
  '/contacts/': typeof AuthedContactsIndexRoute
  '/deals/': typeof AuthedDealsIndexRoute
  '/email/': typeof AuthedEmailIndexRoute
  '/engagement/': typeof AuthedEngagementIndexRoute
  '/invoices/': typeof AuthedInvoicesIndexRoute
  '/leads/': typeof AuthedLeadsIndexRoute
  '/logs/': typeof AuthedLogsIndexRoute
  '/orders/': typeof AuthedOrdersIndexRoute
  '/products/': typeof AuthedProductsIndexRoute
  '/retention/': typeof AuthedRetentionIndexRoute
  '/sequences/': typeof AuthedSequencesIndexRoute
  '/settings/': typeof AuthedSettingsIndexRoute
  '/subscriptions/': typeof AuthedSubscriptionsIndexRoute
  '/tasks/': typeof AuthedTasksIndexRoute
  '/analytics/events/$eventId': typeof AuthedAnalyticsEventsEventIdRoute
  '/automations/$workflowId/edit': typeof AuthedAutomationsWorkflowIdEditRoute
  '/bookings/availability/$id': typeof AuthedBookingsAvailabilityIdRoute
  '/bookings/event-types/$id': typeof AuthedBookingsEventTypesIdRoute
  '/settings/general/members': typeof AuthedSettingsGeneralMembersRoute
  '/settings/general/roles': typeof AuthedSettingsGeneralRolesRoute
  '/settings/packs/$packId': typeof AuthedSettingsPacksPackIdRoute
  '/analytics/events/': typeof AuthedAnalyticsEventsIndexRoute
  '/bookings/availability/': typeof AuthedBookingsAvailabilityIndexRoute
  '/bookings/event-types/': typeof AuthedBookingsEventTypesIndexRoute
  '/settings/enrichment/': typeof AuthedSettingsEnrichmentIndexRoute
  '/settings/general/': typeof AuthedSettingsGeneralIndexRoute
  '/settings/integrations/': typeof AuthedSettingsIntegrationsIndexRoute
  '/settings/migration/': typeof AuthedSettingsMigrationIndexRoute
  '/settings/packs/': typeof AuthedSettingsPacksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
  '/book/$slug': typeof BookSlugRoute
  '/agent-workspace/$runId': typeof AuthedAgentWorkspaceRunIdRoute
  '/agent-workspace/automations': typeof AuthedAgentWorkspaceAutomationsRoute
  '/agent-workspace/functions': typeof AuthedAgentWorkspaceFunctionsRoute
  '/agent-workspace/memory': typeof AuthedAgentWorkspaceMemoryRoute
  '/agent-workspace/models': typeof AuthedAgentWorkspaceModelsRoute
  '/agent-workspace/monitor': typeof AuthedAgentWorkspaceMonitorRoute
  '/agent-workspace/runs': typeof AuthedAgentWorkspaceRunsRoute
  '/agent-workspace/skills': typeof AuthedAgentWorkspaceSkillsRoute
  '/analytics/pipeline': typeof AuthedAnalyticsPipelineRoute
  '/analytics/reports': typeof AuthedAnalyticsReportsRoute
  '/automations/new': typeof AuthedAutomationsNewRoute
  '/bookings/workflows': typeof AuthedBookingsWorkflowsRoute
  '/companies/$companyId': typeof AuthedCompaniesCompanyIdRoute
  '/contacts/$contactId': typeof AuthedContactsContactIdRoute
  '/deals/$dealId': typeof AuthedDealsDealIdRoute
  '/engagement/$eventId': typeof AuthedEngagementEventIdRoute
  '/engagement/events': typeof AuthedEngagementEventsRoute
  '/engagement/preferences': typeof AuthedEngagementPreferencesRoute
  '/invoices/$invoiceId': typeof AuthedInvoicesInvoiceIdRoute
  '/logs/change-history': typeof AuthedLogsChangeHistoryRoute
  '/logs/messages': typeof AuthedLogsMessagesRoute
  '/retention/cancellations': typeof AuthedRetentionCancellationsRoute
  '/retention/opportunities': typeof AuthedRetentionOpportunitiesRoute
  '/retention/renewals': typeof AuthedRetentionRenewalsRoute
  '/retention/triggers': typeof AuthedRetentionTriggersRoute
  '/settings/fields': typeof AuthedSettingsFieldsRoute
  '/settings/model-providers': typeof AuthedSettingsModelProvidersRoute
  '/settings/navigation': typeof AuthedSettingsNavigationRoute
  '/settings/teams': typeof AuthedSettingsTeamsRoute
  '/subscriptions/$subscriptionId': typeof AuthedSubscriptionsSubscriptionIdRoute
  '/booking/$id/cancel': typeof BookingIdCancelRoute
  '/booking/$id/reschedule': typeof BookingIdRescheduleRoute
  '/agent-workspace': typeof AuthedAgentWorkspaceIndexRoute
  '/analytics': typeof AuthedAnalyticsIndexRoute
  '/approvals': typeof AuthedApprovalsIndexRoute
  '/automations': typeof AuthedAutomationsIndexRoute
  '/baskets': typeof AuthedBasketsIndexRoute
  '/bookings': typeof AuthedBookingsIndexRoute
  '/companies': typeof AuthedCompaniesIndexRoute
  '/contacts': typeof AuthedContactsIndexRoute
  '/deals': typeof AuthedDealsIndexRoute
  '/email': typeof AuthedEmailIndexRoute
  '/engagement': typeof AuthedEngagementIndexRoute
  '/invoices': typeof AuthedInvoicesIndexRoute
  '/leads': typeof AuthedLeadsIndexRoute
  '/logs': typeof AuthedLogsIndexRoute
  '/orders': typeof AuthedOrdersIndexRoute
  '/products': typeof AuthedProductsIndexRoute
  '/retention': typeof AuthedRetentionIndexRoute
  '/sequences': typeof AuthedSequencesIndexRoute
  '/settings': typeof AuthedSettingsIndexRoute
  '/subscriptions': typeof AuthedSubscriptionsIndexRoute
  '/tasks': typeof AuthedTasksIndexRoute
  '/analytics/events/$eventId': typeof AuthedAnalyticsEventsEventIdRoute
  '/automations/$workflowId/edit': typeof AuthedAutomationsWorkflowIdEditRoute
  '/bookings/availability/$id': typeof AuthedBookingsAvailabilityIdRoute
  '/bookings/event-types/$id': typeof AuthedBookingsEventTypesIdRoute
  '/settings/general/members': typeof AuthedSettingsGeneralMembersRoute
  '/settings/general/roles': typeof AuthedSettingsGeneralRolesRoute
  '/settings/packs/$packId': typeof AuthedSettingsPacksPackIdRoute
  '/analytics/events': typeof AuthedAnalyticsEventsIndexRoute
  '/bookings/availability': typeof AuthedBookingsAvailabilityIndexRoute
  '/bookings/event-types': typeof AuthedBookingsEventTypesIndexRoute
  '/settings/enrichment': typeof AuthedSettingsEnrichmentIndexRoute
  '/settings/general': typeof AuthedSettingsGeneralIndexRoute
  '/settings/integrations': typeof AuthedSettingsIntegrationsIndexRoute
  '/settings/migration': typeof AuthedSettingsMigrationIndexRoute
  '/settings/packs': typeof AuthedSettingsPacksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_authed': typeof AuthedRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/book/$slug': typeof BookSlugRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/agent-workspace/$runId': typeof AuthedAgentWorkspaceRunIdRoute
  '/_authed/agent-workspace/automations': typeof AuthedAgentWorkspaceAutomationsRoute
  '/_authed/agent-workspace/functions': typeof AuthedAgentWorkspaceFunctionsRoute
  '/_authed/agent-workspace/memory': typeof AuthedAgentWorkspaceMemoryRoute
  '/_authed/agent-workspace/models': typeof AuthedAgentWorkspaceModelsRoute
  '/_authed/agent-workspace/monitor': typeof AuthedAgentWorkspaceMonitorRoute
  '/_authed/agent-workspace/runs': typeof AuthedAgentWorkspaceRunsRoute
  '/_authed/agent-workspace/skills': typeof AuthedAgentWorkspaceSkillsRoute
  '/_authed/analytics/pipeline': typeof AuthedAnalyticsPipelineRoute
  '/_authed/analytics/reports': typeof AuthedAnalyticsReportsRoute
  '/_authed/automations/new': typeof AuthedAutomationsNewRoute
  '/_authed/bookings/availability': typeof AuthedBookingsAvailabilityRouteWithChildren
  '/_authed/bookings/event-types': typeof AuthedBookingsEventTypesRouteWithChildren
  '/_authed/bookings/workflows': typeof AuthedBookingsWorkflowsRoute
  '/_authed/companies/$companyId': typeof AuthedCompaniesCompanyIdRoute
  '/_authed/contacts/$contactId': typeof AuthedContactsContactIdRoute
  '/_authed/deals/$dealId': typeof AuthedDealsDealIdRoute
  '/_authed/engagement/$eventId': typeof AuthedEngagementEventIdRoute
  '/_authed/engagement/events': typeof AuthedEngagementEventsRoute
  '/_authed/engagement/preferences': typeof AuthedEngagementPreferencesRoute
  '/_authed/invoices/$invoiceId': typeof AuthedInvoicesInvoiceIdRoute
  '/_authed/logs/change-history': typeof AuthedLogsChangeHistoryRoute
  '/_authed/logs/messages': typeof AuthedLogsMessagesRoute
  '/_authed/retention/cancellations': typeof AuthedRetentionCancellationsRoute
  '/_authed/retention/opportunities': typeof AuthedRetentionOpportunitiesRoute
  '/_authed/retention/renewals': typeof AuthedRetentionRenewalsRoute
  '/_authed/retention/triggers': typeof AuthedRetentionTriggersRoute
  '/_authed/settings/fields': typeof AuthedSettingsFieldsRoute
  '/_authed/settings/model-providers': typeof AuthedSettingsModelProvidersRoute
  '/_authed/settings/navigation': typeof AuthedSettingsNavigationRoute
  '/_authed/settings/teams': typeof AuthedSettingsTeamsRoute
  '/_authed/subscriptions/$subscriptionId': typeof AuthedSubscriptionsSubscriptionIdRoute
  '/booking/$id/cancel': typeof BookingIdCancelRoute
  '/booking/$id/reschedule': typeof BookingIdRescheduleRoute
  '/_authed/agent-workspace/': typeof AuthedAgentWorkspaceIndexRoute
  '/_authed/analytics/': typeof AuthedAnalyticsIndexRoute
  '/_authed/approvals/': typeof AuthedApprovalsIndexRoute
  '/_authed/automations/': typeof AuthedAutomationsIndexRoute
  '/_authed/baskets/': typeof AuthedBasketsIndexRoute
  '/_authed/bookings/': typeof AuthedBookingsIndexRoute
  '/_authed/companies/': typeof AuthedCompaniesIndexRoute
  '/_authed/contacts/': typeof AuthedContactsIndexRoute
  '/_authed/deals/': typeof AuthedDealsIndexRoute
  '/_authed/email/': typeof AuthedEmailIndexRoute
  '/_authed/engagement/': typeof AuthedEngagementIndexRoute
  '/_authed/invoices/': typeof AuthedInvoicesIndexRoute
  '/_authed/leads/': typeof AuthedLeadsIndexRoute
  '/_authed/logs/': typeof AuthedLogsIndexRoute
  '/_authed/orders/': typeof AuthedOrdersIndexRoute
  '/_authed/products/': typeof AuthedProductsIndexRoute
  '/_authed/retention/': typeof AuthedRetentionIndexRoute
  '/_authed/sequences/': typeof AuthedSequencesIndexRoute
  '/_authed/settings/': typeof AuthedSettingsIndexRoute
  '/_authed/subscriptions/': typeof AuthedSubscriptionsIndexRoute
  '/_authed/tasks/': typeof AuthedTasksIndexRoute
  '/_authed/analytics/events/$eventId': typeof AuthedAnalyticsEventsEventIdRoute
  '/_authed/automations/$workflowId/edit': typeof AuthedAutomationsWorkflowIdEditRoute
  '/_authed/bookings/availability/$id': typeof AuthedBookingsAvailabilityIdRoute
  '/_authed/bookings/event-types/$id': typeof AuthedBookingsEventTypesIdRoute
  '/_authed/settings/general/members': typeof AuthedSettingsGeneralMembersRoute
  '/_authed/settings/general/roles': typeof AuthedSettingsGeneralRolesRoute
  '/_authed/settings/packs/$packId': typeof AuthedSettingsPacksPackIdRoute
  '/_authed/analytics/events/': typeof AuthedAnalyticsEventsIndexRoute
  '/_authed/bookings/availability/': typeof AuthedBookingsAvailabilityIndexRoute
  '/_authed/bookings/event-types/': typeof AuthedBookingsEventTypesIndexRoute
  '/_authed/settings/enrichment/': typeof AuthedSettingsEnrichmentIndexRoute
  '/_authed/settings/general/': typeof AuthedSettingsGeneralIndexRoute
  '/_authed/settings/integrations/': typeof AuthedSettingsIntegrationsIndexRoute
  '/_authed/settings/migration/': typeof AuthedSettingsMigrationIndexRoute
  '/_authed/settings/packs/': typeof AuthedSettingsPacksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/book/$slug'
    | '/agent-workspace/$runId'
    | '/agent-workspace/automations'
    | '/agent-workspace/functions'
    | '/agent-workspace/memory'
    | '/agent-workspace/models'
    | '/agent-workspace/monitor'
    | '/agent-workspace/runs'
    | '/agent-workspace/skills'
    | '/analytics/pipeline'
    | '/analytics/reports'
    | '/automations/new'
    | '/bookings/availability'
    | '/bookings/event-types'
    | '/bookings/workflows'
    | '/companies/$companyId'
    | '/contacts/$contactId'
    | '/deals/$dealId'
    | '/engagement/$eventId'
    | '/engagement/events'
    | '/engagement/preferences'
    | '/invoices/$invoiceId'
    | '/logs/change-history'
    | '/logs/messages'
    | '/retention/cancellations'
    | '/retention/opportunities'
    | '/retention/renewals'
    | '/retention/triggers'
    | '/settings/fields'
    | '/settings/model-providers'
    | '/settings/navigation'
    | '/settings/teams'
    | '/subscriptions/$subscriptionId'
    | '/booking/$id/cancel'
    | '/booking/$id/reschedule'
    | '/agent-workspace/'
    | '/analytics/'
    | '/approvals/'
    | '/automations/'
    | '/baskets/'
    | '/bookings/'
    | '/companies/'
    | '/contacts/'
    | '/deals/'
    | '/email/'
    | '/engagement/'
    | '/invoices/'
    | '/leads/'
    | '/logs/'
    | '/orders/'
    | '/products/'
    | '/retention/'
    | '/sequences/'
    | '/settings/'
    | '/subscriptions/'
    | '/tasks/'
    | '/analytics/events/$eventId'
    | '/automations/$workflowId/edit'
    | '/bookings/availability/$id'
    | '/bookings/event-types/$id'
    | '/settings/general/members'
    | '/settings/general/roles'
    | '/settings/packs/$packId'
    | '/analytics/events/'
    | '/bookings/availability/'
    | '/bookings/event-types/'
    | '/settings/enrichment/'
    | '/settings/general/'
    | '/settings/integrations/'
    | '/settings/migration/'
    | '/settings/packs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/book/$slug'
    | '/agent-workspace/$runId'
    | '/agent-workspace/automations'
    | '/agent-workspace/functions'
    | '/agent-workspace/memory'
    | '/agent-workspace/models'
    | '/agent-workspace/monitor'
    | '/agent-workspace/runs'
    | '/agent-workspace/skills'
    | '/analytics/pipeline'
    | '/analytics/reports'
    | '/automations/new'
    | '/bookings/workflows'
    | '/companies/$companyId'
    | '/contacts/$contactId'
    | '/deals/$dealId'
    | '/engagement/$eventId'
    | '/engagement/events'
    | '/engagement/preferences'
    | '/invoices/$invoiceId'
    | '/logs/change-history'
    | '/logs/messages'
    | '/retention/cancellations'
    | '/retention/opportunities'
    | '/retention/renewals'
    | '/retention/triggers'
    | '/settings/fields'
    | '/settings/model-providers'
    | '/settings/navigation'
    | '/settings/teams'
    | '/subscriptions/$subscriptionId'
    | '/booking/$id/cancel'
    | '/booking/$id/reschedule'
    | '/agent-workspace'
    | '/analytics'
    | '/approvals'
    | '/automations'
    | '/baskets'
    | '/bookings'
    | '/companies'
    | '/contacts'
    | '/deals'
    | '/email'
    | '/engagement'
    | '/invoices'
    | '/leads'
    | '/logs'
    | '/orders'
    | '/products'
    | '/retention'
    | '/sequences'
    | '/settings'
    | '/subscriptions'
    | '/tasks'
    | '/analytics/events/$eventId'
    | '/automations/$workflowId/edit'
    | '/bookings/availability/$id'
    | '/bookings/event-types/$id'
    | '/settings/general/members'
    | '/settings/general/roles'
    | '/settings/packs/$packId'
    | '/analytics/events'
    | '/bookings/availability'
    | '/bookings/event-types'
    | '/settings/enrichment'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/migration'
    | '/settings/packs'
  id:
    | '__root__'
    | '/_auth'
    | '/_authed'
    | '/_auth/login'
    | '/_auth/signup'
    | '/book/$slug'
    | '/_authed/'
    | '/_authed/agent-workspace/$runId'
    | '/_authed/agent-workspace/automations'
    | '/_authed/agent-workspace/functions'
    | '/_authed/agent-workspace/memory'
    | '/_authed/agent-workspace/models'
    | '/_authed/agent-workspace/monitor'
    | '/_authed/agent-workspace/runs'
    | '/_authed/agent-workspace/skills'
    | '/_authed/analytics/pipeline'
    | '/_authed/analytics/reports'
    | '/_authed/automations/new'
    | '/_authed/bookings/availability'
    | '/_authed/bookings/event-types'
    | '/_authed/bookings/workflows'
    | '/_authed/companies/$companyId'
    | '/_authed/contacts/$contactId'
    | '/_authed/deals/$dealId'
    | '/_authed/engagement/$eventId'
    | '/_authed/engagement/events'
    | '/_authed/engagement/preferences'
    | '/_authed/invoices/$invoiceId'
    | '/_authed/logs/change-history'
    | '/_authed/logs/messages'
    | '/_authed/retention/cancellations'
    | '/_authed/retention/opportunities'
    | '/_authed/retention/renewals'
    | '/_authed/retention/triggers'
    | '/_authed/settings/fields'
    | '/_authed/settings/model-providers'
    | '/_authed/settings/navigation'
    | '/_authed/settings/teams'
    | '/_authed/subscriptions/$subscriptionId'
    | '/booking/$id/cancel'
    | '/booking/$id/reschedule'
    | '/_authed/agent-workspace/'
    | '/_authed/analytics/'
    | '/_authed/approvals/'
    | '/_authed/automations/'
    | '/_authed/baskets/'
    | '/_authed/bookings/'
    | '/_authed/companies/'
    | '/_authed/contacts/'
    | '/_authed/deals/'
    | '/_authed/email/'
    | '/_authed/engagement/'
    | '/_authed/invoices/'
    | '/_authed/leads/'
    | '/_authed/logs/'
    | '/_authed/orders/'
    | '/_authed/products/'
    | '/_authed/retention/'
    | '/_authed/sequences/'
    | '/_authed/settings/'
    | '/_authed/subscriptions/'
    | '/_authed/tasks/'
    | '/_authed/analytics/events/$eventId'
    | '/_authed/automations/$workflowId/edit'
    | '/_authed/bookings/availability/$id'
    | '/_authed/bookings/event-types/$id'
    | '/_authed/settings/general/members'
    | '/_authed/settings/general/roles'
    | '/_authed/settings/packs/$packId'
    | '/_authed/analytics/events/'
    | '/_authed/bookings/availability/'
    | '/_authed/bookings/event-types/'
    | '/_authed/settings/enrichment/'
    | '/_authed/settings/general/'
    | '/_authed/settings/integrations/'
    | '/_authed/settings/migration/'
    | '/_authed/settings/packs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthedRoute: typeof AuthedRouteWithChildren
  BookSlugRoute: typeof BookSlugRoute
  BookingIdCancelRoute: typeof BookingIdCancelRoute
  BookingIdRescheduleRoute: typeof BookingIdRescheduleRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/book/$slug': {
      id: '/book/$slug'
      path: '/book/$slug'
      fullPath: '/book/$slug'
      preLoaderRoute: typeof BookSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authed/tasks/': {
      id: '/_authed/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthedTasksIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/subscriptions/': {
      id: '/_authed/subscriptions/'
      path: '/subscriptions'
      fullPath: '/subscriptions/'
      preLoaderRoute: typeof AuthedSubscriptionsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/': {
      id: '/_authed/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthedSettingsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/sequences/': {
      id: '/_authed/sequences/'
      path: '/sequences'
      fullPath: '/sequences/'
      preLoaderRoute: typeof AuthedSequencesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/retention/': {
      id: '/_authed/retention/'
      path: '/retention'
      fullPath: '/retention/'
      preLoaderRoute: typeof AuthedRetentionIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/products/': {
      id: '/_authed/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthedProductsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/orders/': {
      id: '/_authed/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthedOrdersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/logs/': {
      id: '/_authed/logs/'
      path: '/logs'
      fullPath: '/logs/'
      preLoaderRoute: typeof AuthedLogsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/leads/': {
      id: '/_authed/leads/'
      path: '/leads'
      fullPath: '/leads/'
      preLoaderRoute: typeof AuthedLeadsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/invoices/': {
      id: '/_authed/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthedInvoicesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/engagement/': {
      id: '/_authed/engagement/'
      path: '/engagement'
      fullPath: '/engagement/'
      preLoaderRoute: typeof AuthedEngagementIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/email/': {
      id: '/_authed/email/'
      path: '/email'
      fullPath: '/email/'
      preLoaderRoute: typeof AuthedEmailIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/deals/': {
      id: '/_authed/deals/'
      path: '/deals'
      fullPath: '/deals/'
      preLoaderRoute: typeof AuthedDealsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/contacts/': {
      id: '/_authed/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AuthedContactsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/companies/': {
      id: '/_authed/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthedCompaniesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/bookings/': {
      id: '/_authed/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof AuthedBookingsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/baskets/': {
      id: '/_authed/baskets/'
      path: '/baskets'
      fullPath: '/baskets/'
      preLoaderRoute: typeof AuthedBasketsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/automations/': {
      id: '/_authed/automations/'
      path: '/automations'
      fullPath: '/automations/'
      preLoaderRoute: typeof AuthedAutomationsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/approvals/': {
      id: '/_authed/approvals/'
      path: '/approvals'
      fullPath: '/approvals/'
      preLoaderRoute: typeof AuthedApprovalsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics/': {
      id: '/_authed/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthedAnalyticsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agent-workspace/': {
      id: '/_authed/agent-workspace/'
      path: '/agent-workspace'
      fullPath: '/agent-workspace/'
      preLoaderRoute: typeof AuthedAgentWorkspaceIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/booking/$id/reschedule': {
      id: '/booking/$id/reschedule'
      path: '/booking/$id/reschedule'
      fullPath: '/booking/$id/reschedule'
      preLoaderRoute: typeof BookingIdRescheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/$id/cancel': {
      id: '/booking/$id/cancel'
      path: '/booking/$id/cancel'
      fullPath: '/booking/$id/cancel'
      preLoaderRoute: typeof BookingIdCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/subscriptions/$subscriptionId': {
      id: '/_authed/subscriptions/$subscriptionId'
      path: '/subscriptions/$subscriptionId'
      fullPath: '/subscriptions/$subscriptionId'
      preLoaderRoute: typeof AuthedSubscriptionsSubscriptionIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/teams': {
      id: '/_authed/settings/teams'
      path: '/settings/teams'
      fullPath: '/settings/teams'
      preLoaderRoute: typeof AuthedSettingsTeamsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/navigation': {
      id: '/_authed/settings/navigation'
      path: '/settings/navigation'
      fullPath: '/settings/navigation'
      preLoaderRoute: typeof AuthedSettingsNavigationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/model-providers': {
      id: '/_authed/settings/model-providers'
      path: '/settings/model-providers'
      fullPath: '/settings/model-providers'
      preLoaderRoute: typeof AuthedSettingsModelProvidersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/fields': {
      id: '/_authed/settings/fields'
      path: '/settings/fields'
      fullPath: '/settings/fields'
      preLoaderRoute: typeof AuthedSettingsFieldsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/retention/triggers': {
      id: '/_authed/retention/triggers'
      path: '/retention/triggers'
      fullPath: '/retention/triggers'
      preLoaderRoute: typeof AuthedRetentionTriggersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/retention/renewals': {
      id: '/_authed/retention/renewals'
      path: '/retention/renewals'
      fullPath: '/retention/renewals'
      preLoaderRoute: typeof AuthedRetentionRenewalsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/retention/opportunities': {
      id: '/_authed/retention/opportunities'
      path: '/retention/opportunities'
      fullPath: '/retention/opportunities'
      preLoaderRoute: typeof AuthedRetentionOpportunitiesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/retention/cancellations': {
      id: '/_authed/retention/cancellations'
      path: '/retention/cancellations'
      fullPath: '/retention/cancellations'
      preLoaderRoute: typeof AuthedRetentionCancellationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/logs/messages': {
      id: '/_authed/logs/messages'
      path: '/logs/messages'
      fullPath: '/logs/messages'
      preLoaderRoute: typeof AuthedLogsMessagesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/logs/change-history': {
      id: '/_authed/logs/change-history'
      path: '/logs/change-history'
      fullPath: '/logs/change-history'
      preLoaderRoute: typeof AuthedLogsChangeHistoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/invoices/$invoiceId': {
      id: '/_authed/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AuthedInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/engagement/preferences': {
      id: '/_authed/engagement/preferences'
      path: '/engagement/preferences'
      fullPath: '/engagement/preferences'
      preLoaderRoute: typeof AuthedEngagementPreferencesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/engagement/events': {
      id: '/_authed/engagement/events'
      path: '/engagement/events'
      fullPath: '/engagement/events'
      preLoaderRoute: typeof AuthedEngagementEventsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/engagement/$eventId': {
      id: '/_authed/engagement/$eventId'
      path: '/engagement/$eventId'
      fullPath: '/engagement/$eventId'
      preLoaderRoute: typeof AuthedEngagementEventIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/deals/$dealId': {
      id: '/_authed/deals/$dealId'
      path: '/deals/$dealId'
      fullPath: '/deals/$dealId'
      preLoaderRoute: typeof AuthedDealsDealIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/contacts/$contactId': {
      id: '/_authed/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AuthedContactsContactIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/companies/$companyId': {
      id: '/_authed/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AuthedCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/bookings/workflows': {
      id: '/_authed/bookings/workflows'
      path: '/bookings/workflows'
      fullPath: '/bookings/workflows'
      preLoaderRoute: typeof AuthedBookingsWorkflowsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/bookings/event-types': {
      id: '/_authed/bookings/event-types'
      path: '/bookings/event-types'
      fullPath: '/bookings/event-types'
      preLoaderRoute: typeof AuthedBookingsEventTypesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/bookings/availability': {
      id: '/_authed/bookings/availability'
      path: '/bookings/availability'
      fullPath: '/bookings/availability'
      preLoaderRoute: typeof AuthedBookingsAvailabilityRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/automations/new': {
      id: '/_authed/automations/new'
      path: '/automations/new'
      fullPath: '/automations/new'
      preLoaderRoute: typeof AuthedAutomationsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics/reports': {
      id: '/_authed/analytics/reports'
      path: '/analytics/reports'
      fullPath: '/analytics/reports'
      preLoaderRoute: typeof AuthedAnalyticsReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics/pipeline': {
      id: '/_authed/analytics/pipeline'
      path: '/analytics/pipeline'
      fullPath: '/analytics/pipeline'
      preLoaderRoute: typeof AuthedAnalyticsPipelineRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agent-workspace/skills': {
      id: '/_authed/agent-workspace/skills'
      path: '/agent-workspace/skills'
      fullPath: '/agent-workspace/skills'
      preLoaderRoute: typeof AuthedAgentWorkspaceSkillsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agent-workspace/runs': {
      id: '/_authed/agent-workspace/runs'
      path: '/agent-workspace/runs'
      fullPath: '/agent-workspace/runs'
      preLoaderRoute: typeof AuthedAgentWorkspaceRunsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agent-workspace/monitor': {
      id: '/_authed/agent-workspace/monitor'
      path: '/agent-workspace/monitor'
      fullPath: '/agent-workspace/monitor'
      preLoaderRoute: typeof AuthedAgentWorkspaceMonitorRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agent-workspace/models': {
      id: '/_authed/agent-workspace/models'
      path: '/agent-workspace/models'
      fullPath: '/agent-workspace/models'
      preLoaderRoute: typeof AuthedAgentWorkspaceModelsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agent-workspace/memory': {
      id: '/_authed/agent-workspace/memory'
      path: '/agent-workspace/memory'
      fullPath: '/agent-workspace/memory'
      preLoaderRoute: typeof AuthedAgentWorkspaceMemoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agent-workspace/functions': {
      id: '/_authed/agent-workspace/functions'
      path: '/agent-workspace/functions'
      fullPath: '/agent-workspace/functions'
      preLoaderRoute: typeof AuthedAgentWorkspaceFunctionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agent-workspace/automations': {
      id: '/_authed/agent-workspace/automations'
      path: '/agent-workspace/automations'
      fullPath: '/agent-workspace/automations'
      preLoaderRoute: typeof AuthedAgentWorkspaceAutomationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agent-workspace/$runId': {
      id: '/_authed/agent-workspace/$runId'
      path: '/agent-workspace/$runId'
      fullPath: '/agent-workspace/$runId'
      preLoaderRoute: typeof AuthedAgentWorkspaceRunIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/packs/': {
      id: '/_authed/settings/packs/'
      path: '/settings/packs'
      fullPath: '/settings/packs/'
      preLoaderRoute: typeof AuthedSettingsPacksIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/migration/': {
      id: '/_authed/settings/migration/'
      path: '/settings/migration'
      fullPath: '/settings/migration/'
      preLoaderRoute: typeof AuthedSettingsMigrationIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/integrations/': {
      id: '/_authed/settings/integrations/'
      path: '/settings/integrations'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof AuthedSettingsIntegrationsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/general/': {
      id: '/_authed/settings/general/'
      path: '/settings/general'
      fullPath: '/settings/general/'
      preLoaderRoute: typeof AuthedSettingsGeneralIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/enrichment/': {
      id: '/_authed/settings/enrichment/'
      path: '/settings/enrichment'
      fullPath: '/settings/enrichment/'
      preLoaderRoute: typeof AuthedSettingsEnrichmentIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/bookings/event-types/': {
      id: '/_authed/bookings/event-types/'
      path: '/'
      fullPath: '/bookings/event-types/'
      preLoaderRoute: typeof AuthedBookingsEventTypesIndexRouteImport
      parentRoute: typeof AuthedBookingsEventTypesRoute
    }
    '/_authed/bookings/availability/': {
      id: '/_authed/bookings/availability/'
      path: '/'
      fullPath: '/bookings/availability/'
      preLoaderRoute: typeof AuthedBookingsAvailabilityIndexRouteImport
      parentRoute: typeof AuthedBookingsAvailabilityRoute
    }
    '/_authed/analytics/events/': {
      id: '/_authed/analytics/events/'
      path: '/analytics/events'
      fullPath: '/analytics/events/'
      preLoaderRoute: typeof AuthedAnalyticsEventsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/packs/$packId': {
      id: '/_authed/settings/packs/$packId'
      path: '/settings/packs/$packId'
      fullPath: '/settings/packs/$packId'
      preLoaderRoute: typeof AuthedSettingsPacksPackIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/general/roles': {
      id: '/_authed/settings/general/roles'
      path: '/settings/general/roles'
      fullPath: '/settings/general/roles'
      preLoaderRoute: typeof AuthedSettingsGeneralRolesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/general/members': {
      id: '/_authed/settings/general/members'
      path: '/settings/general/members'
      fullPath: '/settings/general/members'
      preLoaderRoute: typeof AuthedSettingsGeneralMembersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/bookings/event-types/$id': {
      id: '/_authed/bookings/event-types/$id'
      path: '/$id'
      fullPath: '/bookings/event-types/$id'
      preLoaderRoute: typeof AuthedBookingsEventTypesIdRouteImport
      parentRoute: typeof AuthedBookingsEventTypesRoute
    }
    '/_authed/bookings/availability/$id': {
      id: '/_authed/bookings/availability/$id'
      path: '/$id'
      fullPath: '/bookings/availability/$id'
      preLoaderRoute: typeof AuthedBookingsAvailabilityIdRouteImport
      parentRoute: typeof AuthedBookingsAvailabilityRoute
    }
    '/_authed/automations/$workflowId/edit': {
      id: '/_authed/automations/$workflowId/edit'
      path: '/automations/$workflowId/edit'
      fullPath: '/automations/$workflowId/edit'
      preLoaderRoute: typeof AuthedAutomationsWorkflowIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics/events/$eventId': {
      id: '/_authed/analytics/events/$eventId'
      path: '/analytics/events/$eventId'
      fullPath: '/analytics/events/$eventId'
      preLoaderRoute: typeof AuthedAnalyticsEventsEventIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthedBookingsAvailabilityRouteChildren {
  AuthedBookingsAvailabilityIdRoute: typeof AuthedBookingsAvailabilityIdRoute
  AuthedBookingsAvailabilityIndexRoute: typeof AuthedBookingsAvailabilityIndexRoute
}

const AuthedBookingsAvailabilityRouteChildren: AuthedBookingsAvailabilityRouteChildren =
  {
    AuthedBookingsAvailabilityIdRoute: AuthedBookingsAvailabilityIdRoute,
    AuthedBookingsAvailabilityIndexRoute: AuthedBookingsAvailabilityIndexRoute,
  }

const AuthedBookingsAvailabilityRouteWithChildren =
  AuthedBookingsAvailabilityRoute._addFileChildren(
    AuthedBookingsAvailabilityRouteChildren,
  )

interface AuthedBookingsEventTypesRouteChildren {
  AuthedBookingsEventTypesIdRoute: typeof AuthedBookingsEventTypesIdRoute
  AuthedBookingsEventTypesIndexRoute: typeof AuthedBookingsEventTypesIndexRoute
}

const AuthedBookingsEventTypesRouteChildren: AuthedBookingsEventTypesRouteChildren =
  {
    AuthedBookingsEventTypesIdRoute: AuthedBookingsEventTypesIdRoute,
    AuthedBookingsEventTypesIndexRoute: AuthedBookingsEventTypesIndexRoute,
  }

const AuthedBookingsEventTypesRouteWithChildren =
  AuthedBookingsEventTypesRoute._addFileChildren(
    AuthedBookingsEventTypesRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAgentWorkspaceRunIdRoute: typeof AuthedAgentWorkspaceRunIdRoute
  AuthedAgentWorkspaceAutomationsRoute: typeof AuthedAgentWorkspaceAutomationsRoute
  AuthedAgentWorkspaceFunctionsRoute: typeof AuthedAgentWorkspaceFunctionsRoute
  AuthedAgentWorkspaceMemoryRoute: typeof AuthedAgentWorkspaceMemoryRoute
  AuthedAgentWorkspaceModelsRoute: typeof AuthedAgentWorkspaceModelsRoute
  AuthedAgentWorkspaceMonitorRoute: typeof AuthedAgentWorkspaceMonitorRoute
  AuthedAgentWorkspaceRunsRoute: typeof AuthedAgentWorkspaceRunsRoute
  AuthedAgentWorkspaceSkillsRoute: typeof AuthedAgentWorkspaceSkillsRoute
  AuthedAnalyticsPipelineRoute: typeof AuthedAnalyticsPipelineRoute
  AuthedAnalyticsReportsRoute: typeof AuthedAnalyticsReportsRoute
  AuthedAutomationsNewRoute: typeof AuthedAutomationsNewRoute
  AuthedBookingsAvailabilityRoute: typeof AuthedBookingsAvailabilityRouteWithChildren
  AuthedBookingsEventTypesRoute: typeof AuthedBookingsEventTypesRouteWithChildren
  AuthedBookingsWorkflowsRoute: typeof AuthedBookingsWorkflowsRoute
  AuthedCompaniesCompanyIdRoute: typeof AuthedCompaniesCompanyIdRoute
  AuthedContactsContactIdRoute: typeof AuthedContactsContactIdRoute
  AuthedDealsDealIdRoute: typeof AuthedDealsDealIdRoute
  AuthedEngagementEventIdRoute: typeof AuthedEngagementEventIdRoute
  AuthedEngagementEventsRoute: typeof AuthedEngagementEventsRoute
  AuthedEngagementPreferencesRoute: typeof AuthedEngagementPreferencesRoute
  AuthedInvoicesInvoiceIdRoute: typeof AuthedInvoicesInvoiceIdRoute
  AuthedLogsChangeHistoryRoute: typeof AuthedLogsChangeHistoryRoute
  AuthedLogsMessagesRoute: typeof AuthedLogsMessagesRoute
  AuthedRetentionCancellationsRoute: typeof AuthedRetentionCancellationsRoute
  AuthedRetentionOpportunitiesRoute: typeof AuthedRetentionOpportunitiesRoute
  AuthedRetentionRenewalsRoute: typeof AuthedRetentionRenewalsRoute
  AuthedRetentionTriggersRoute: typeof AuthedRetentionTriggersRoute
  AuthedSettingsFieldsRoute: typeof AuthedSettingsFieldsRoute
  AuthedSettingsModelProvidersRoute: typeof AuthedSettingsModelProvidersRoute
  AuthedSettingsNavigationRoute: typeof AuthedSettingsNavigationRoute
  AuthedSettingsTeamsRoute: typeof AuthedSettingsTeamsRoute
  AuthedSubscriptionsSubscriptionIdRoute: typeof AuthedSubscriptionsSubscriptionIdRoute
  AuthedAgentWorkspaceIndexRoute: typeof AuthedAgentWorkspaceIndexRoute
  AuthedAnalyticsIndexRoute: typeof AuthedAnalyticsIndexRoute
  AuthedApprovalsIndexRoute: typeof AuthedApprovalsIndexRoute
  AuthedAutomationsIndexRoute: typeof AuthedAutomationsIndexRoute
  AuthedBasketsIndexRoute: typeof AuthedBasketsIndexRoute
  AuthedBookingsIndexRoute: typeof AuthedBookingsIndexRoute
  AuthedCompaniesIndexRoute: typeof AuthedCompaniesIndexRoute
  AuthedContactsIndexRoute: typeof AuthedContactsIndexRoute
  AuthedDealsIndexRoute: typeof AuthedDealsIndexRoute
  AuthedEmailIndexRoute: typeof AuthedEmailIndexRoute
  AuthedEngagementIndexRoute: typeof AuthedEngagementIndexRoute
  AuthedInvoicesIndexRoute: typeof AuthedInvoicesIndexRoute
  AuthedLeadsIndexRoute: typeof AuthedLeadsIndexRoute
  AuthedLogsIndexRoute: typeof AuthedLogsIndexRoute
  AuthedOrdersIndexRoute: typeof AuthedOrdersIndexRoute
  AuthedProductsIndexRoute: typeof AuthedProductsIndexRoute
  AuthedRetentionIndexRoute: typeof AuthedRetentionIndexRoute
  AuthedSequencesIndexRoute: typeof AuthedSequencesIndexRoute
  AuthedSettingsIndexRoute: typeof AuthedSettingsIndexRoute
  AuthedSubscriptionsIndexRoute: typeof AuthedSubscriptionsIndexRoute
  AuthedTasksIndexRoute: typeof AuthedTasksIndexRoute
  AuthedAnalyticsEventsEventIdRoute: typeof AuthedAnalyticsEventsEventIdRoute
  AuthedAutomationsWorkflowIdEditRoute: typeof AuthedAutomationsWorkflowIdEditRoute
  AuthedSettingsGeneralMembersRoute: typeof AuthedSettingsGeneralMembersRoute
  AuthedSettingsGeneralRolesRoute: typeof AuthedSettingsGeneralRolesRoute
  AuthedSettingsPacksPackIdRoute: typeof AuthedSettingsPacksPackIdRoute
  AuthedAnalyticsEventsIndexRoute: typeof AuthedAnalyticsEventsIndexRoute
  AuthedSettingsEnrichmentIndexRoute: typeof AuthedSettingsEnrichmentIndexRoute
  AuthedSettingsGeneralIndexRoute: typeof AuthedSettingsGeneralIndexRoute
  AuthedSettingsIntegrationsIndexRoute: typeof AuthedSettingsIntegrationsIndexRoute
  AuthedSettingsMigrationIndexRoute: typeof AuthedSettingsMigrationIndexRoute
  AuthedSettingsPacksIndexRoute: typeof AuthedSettingsPacksIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAgentWorkspaceRunIdRoute: AuthedAgentWorkspaceRunIdRoute,
  AuthedAgentWorkspaceAutomationsRoute: AuthedAgentWorkspaceAutomationsRoute,
  AuthedAgentWorkspaceFunctionsRoute: AuthedAgentWorkspaceFunctionsRoute,
  AuthedAgentWorkspaceMemoryRoute: AuthedAgentWorkspaceMemoryRoute,
  AuthedAgentWorkspaceModelsRoute: AuthedAgentWorkspaceModelsRoute,
  AuthedAgentWorkspaceMonitorRoute: AuthedAgentWorkspaceMonitorRoute,
  AuthedAgentWorkspaceRunsRoute: AuthedAgentWorkspaceRunsRoute,
  AuthedAgentWorkspaceSkillsRoute: AuthedAgentWorkspaceSkillsRoute,
  AuthedAnalyticsPipelineRoute: AuthedAnalyticsPipelineRoute,
  AuthedAnalyticsReportsRoute: AuthedAnalyticsReportsRoute,
  AuthedAutomationsNewRoute: AuthedAutomationsNewRoute,
  AuthedBookingsAvailabilityRoute: AuthedBookingsAvailabilityRouteWithChildren,
  AuthedBookingsEventTypesRoute: AuthedBookingsEventTypesRouteWithChildren,
  AuthedBookingsWorkflowsRoute: AuthedBookingsWorkflowsRoute,
  AuthedCompaniesCompanyIdRoute: AuthedCompaniesCompanyIdRoute,
  AuthedContactsContactIdRoute: AuthedContactsContactIdRoute,
  AuthedDealsDealIdRoute: AuthedDealsDealIdRoute,
  AuthedEngagementEventIdRoute: AuthedEngagementEventIdRoute,
  AuthedEngagementEventsRoute: AuthedEngagementEventsRoute,
  AuthedEngagementPreferencesRoute: AuthedEngagementPreferencesRoute,
  AuthedInvoicesInvoiceIdRoute: AuthedInvoicesInvoiceIdRoute,
  AuthedLogsChangeHistoryRoute: AuthedLogsChangeHistoryRoute,
  AuthedLogsMessagesRoute: AuthedLogsMessagesRoute,
  AuthedRetentionCancellationsRoute: AuthedRetentionCancellationsRoute,
  AuthedRetentionOpportunitiesRoute: AuthedRetentionOpportunitiesRoute,
  AuthedRetentionRenewalsRoute: AuthedRetentionRenewalsRoute,
  AuthedRetentionTriggersRoute: AuthedRetentionTriggersRoute,
  AuthedSettingsFieldsRoute: AuthedSettingsFieldsRoute,
  AuthedSettingsModelProvidersRoute: AuthedSettingsModelProvidersRoute,
  AuthedSettingsNavigationRoute: AuthedSettingsNavigationRoute,
  AuthedSettingsTeamsRoute: AuthedSettingsTeamsRoute,
  AuthedSubscriptionsSubscriptionIdRoute:
    AuthedSubscriptionsSubscriptionIdRoute,
  AuthedAgentWorkspaceIndexRoute: AuthedAgentWorkspaceIndexRoute,
  AuthedAnalyticsIndexRoute: AuthedAnalyticsIndexRoute,
  AuthedApprovalsIndexRoute: AuthedApprovalsIndexRoute,
  AuthedAutomationsIndexRoute: AuthedAutomationsIndexRoute,
  AuthedBasketsIndexRoute: AuthedBasketsIndexRoute,
  AuthedBookingsIndexRoute: AuthedBookingsIndexRoute,
  AuthedCompaniesIndexRoute: AuthedCompaniesIndexRoute,
  AuthedContactsIndexRoute: AuthedContactsIndexRoute,
  AuthedDealsIndexRoute: AuthedDealsIndexRoute,
  AuthedEmailIndexRoute: AuthedEmailIndexRoute,
  AuthedEngagementIndexRoute: AuthedEngagementIndexRoute,
  AuthedInvoicesIndexRoute: AuthedInvoicesIndexRoute,
  AuthedLeadsIndexRoute: AuthedLeadsIndexRoute,
  AuthedLogsIndexRoute: AuthedLogsIndexRoute,
  AuthedOrdersIndexRoute: AuthedOrdersIndexRoute,
  AuthedProductsIndexRoute: AuthedProductsIndexRoute,
  AuthedRetentionIndexRoute: AuthedRetentionIndexRoute,
  AuthedSequencesIndexRoute: AuthedSequencesIndexRoute,
  AuthedSettingsIndexRoute: AuthedSettingsIndexRoute,
  AuthedSubscriptionsIndexRoute: AuthedSubscriptionsIndexRoute,
  AuthedTasksIndexRoute: AuthedTasksIndexRoute,
  AuthedAnalyticsEventsEventIdRoute: AuthedAnalyticsEventsEventIdRoute,
  AuthedAutomationsWorkflowIdEditRoute: AuthedAutomationsWorkflowIdEditRoute,
  AuthedSettingsGeneralMembersRoute: AuthedSettingsGeneralMembersRoute,
  AuthedSettingsGeneralRolesRoute: AuthedSettingsGeneralRolesRoute,
  AuthedSettingsPacksPackIdRoute: AuthedSettingsPacksPackIdRoute,
  AuthedAnalyticsEventsIndexRoute: AuthedAnalyticsEventsIndexRoute,
  AuthedSettingsEnrichmentIndexRoute: AuthedSettingsEnrichmentIndexRoute,
  AuthedSettingsGeneralIndexRoute: AuthedSettingsGeneralIndexRoute,
  AuthedSettingsIntegrationsIndexRoute: AuthedSettingsIntegrationsIndexRoute,
  AuthedSettingsMigrationIndexRoute: AuthedSettingsMigrationIndexRoute,
  AuthedSettingsPacksIndexRoute: AuthedSettingsPacksIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthedRoute: AuthedRouteWithChildren,
  BookSlugRoute: BookSlugRoute,
  BookingIdCancelRoute: BookingIdCancelRoute,
  BookingIdRescheduleRoute: BookingIdRescheduleRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
